/// <reference path="./types.d.ts" />

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';

/**
 * From React v18 migration guide
 *
 * @see https://reactjs.org/blog/2022/03/08/react-18-upgrade-guide.html
 */
const container = document.getElementById('root');
const root = createRoot(container!); // eslint-disable-line @typescript-eslint/no-non-null-assertion

root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.register();

/*

MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
Mm::::://///////////////+++++++++++++++NMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
Md.....................................NMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM
Mh.....................................yooooooooo+++++++++++++++++++++++++++++++/:/y+///ss///////+yN
Mh.....................................o/////////::::::::::::::::::::::::::::::-./+---/o:------:+/-N
My.....................................o///////////++//++++++++++++++++++++++:./+---:o/-------++---N
My.....................................-------------------------------------.:+:--:+/-------++---::N
My........................................................................`-+:---++-------++:---://M
My......................................................................`.//---/+:------/+:---:///+M
My....................................................................``:/---/o:------/+:---:///+ssM
Ms..................................................................``:+:--:+/------/+:---:///+so/oM
Ms................................................................``-+:--:++------:+:---::///oo/++/M
Ms...............................................................`.+/---/+:-----:+/---::///os+++-./N
Ms.............................................................`.//---/+:-----:+/---::///os+/+:.-:+N
Ms...........................................................``:+:--:+/------//---::///os+/+:.-::-/N
Mo..........................................................`-+:--:+/------//---::///os+/+/.-::-..:M
Mo........................................................`.+/---/+------:/----:///os+/+/.-::-..../M
Mo......................................................`.//---/+:-----//----:///+s+/++-.:::-...../M
Mo....................................................``:+---:+/-----:/:---:///+s+/++-.:::-......./N
M+...................................................`-+:---+/-----:/:---:///+so//o:.:::-........./N
M+.................................................`.+/---+/-----:/:---:///+so//o:.:::-...........+M
M+...............................................``//---/+-----:/:---:////so//o/.-::-.............+M
M/..............................................`-s/++//:-----/:---:////so//o/.-::-...............+M
M/.............................................`./.```::----//---:////so//o+.-::-.................oN
M/............................................. o`````.o/+/:---:////oo//++.-::-...................oM
M/............................................`:.`````````/:-::///oo//++--::-.....................oM
N/...........................................``+```````````o+++ooo//++--::-.......................oM
N:........................................... +````````````````.s//o:-:::.........................oM
M:..........................................`-/``````````````...so/.:::...........................sN
M:.......................................... dNNh/```````..://///-:::-............................sM
M:.............................-----.......`+MMMMMy..:::///--::-----..............................sM
M-......................-::::-......-:::::.`NMMMNds/:-----........................................sM
N....................-::.``             ``:oho/-..................................................sM
M..................:/.`                    `./-...................................................sM
M................:/.                         `/:..................................................yM
M..............-/.                             +..................................................yM
m.............::`                              `+:::::::::::/:::-.................................yM
m............/-                                 /.            `.-/:...............................hM
N`......----.+                                                    .+-.............................yM
N`.-:/::--.-:.                                                      o.............................hM
N:/-.                                                               /-............................hM
m.                                                                  :/:::://:-....................hM
d                      Made with <3 - @navn-r                               .:/-..................dM
m                                                                             `:+.................dM
d                                                                               .o................dM
d                                                                                -/...............NM
d                                                                                 o..............`NM
h                                                                                 o...............NM
d//::::::::::::::::------------------....```````````````  `                      /:...............NM
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMNNMMMMMMMMMMNNMMNNNNNNmNNNNNNNNNmmmmNNmmmmmmmmmmmmmmddMM
MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM

*/
